import { Link } from "gatsby";
import React from "react";
import { Box } from "../../elements/Box";
import { Flex } from "../../elements/Flex";
import { Text } from "../../elements/Text";
import DownloadButtons from "../DownloadButtons";
import { ExternalLink } from "../../elements/ExternalLink";
import Genflow from "../../images/Genflow.png";
import { Image } from "../../elements/Image";
import SocialButtons from "../SocialButtons";
import { footerLinks } from "./links";
import { BRAND } from "../../utils/assets";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const Footer = () => {
  return (
    <Box bg="#CECCC4" py={4}>
      {/* Main footer content */}
      <Flex flexDirection={["column", "row"]} justifyContent="space-between" pt={24} px={5} mb={[0, 120]} maxWidth="1300px">
        {/* LEAN Logo and Social Links */}
        <Box mb={[4, 0]}>
          <Link to="/">
            <Image src={BRAND.logo} alt="LEAN" width="160px" mb={4} />
          </Link>
          <Box display="flex" alignItems="center">
            <ExternalLink href="https://www.facebook.com/lilly.sabri">
              <FaFacebook size={16} style={{ marginRight: "1rem" }} color="black" />
            </ExternalLink>
            <ExternalLink href="https://twitter.com/lillysabri?lang=en">
              <FaTwitter size={16} style={{ marginRight: "1rem" }} color="black" />
            </ExternalLink>
            <ExternalLink href="https://www.instagram.com/lillysabri/?hl=en">
              <FaInstagram size={16} style={{ marginRight: "1rem" }} color="black" />
            </ExternalLink>
            <ExternalLink href="https://www.youtube.com/channel/UCTsM1dSAiXqiV5oZjuNw_Bg">
              <FaYoutube size={16} color="black" />
            </ExternalLink>
          </Box>
        </Box>

        {/* Information Column */}
        <Box fontSize={14} mb={[4, 0]}>
          <Text fontWeight="600" textTransform="uppercase" mb={3}>
            INFORMATION
          </Text>
          
          <Link to={footerLinks.information.shippingInformation}>
            <Text color="black" mb={2}>
              Shipping Information
            </Text>
          </Link>
          
          <ExternalLink
            textDecoration="none"
            color="black"
            href={footerLinks.information.faq}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text mb={2}>FAQ & Support</Text>
          </ExternalLink>
          
          <Link to={footerLinks.information.refund}>
            <Text color="black" mb={2}>
              Refund Policy
            </Text>
          </Link>
        </Box>

        {/* Legal Column */}
        <Box fontSize={14} mb={[4, 0]}>
          <Text color="black" fontWeight="600" textTransform="uppercase" mb={3}>
            LEGAL
          </Text>

          <Link to={footerLinks.legal.consumerGoods}>
            <Text color="black" mb={2}>
              Consumer Goods T&Cs
            </Text>
          </Link>

          <Link to={footerLinks.legal.acceptableUsePolicy}>
            <Text color="black" mb={2}>
              Acceptable Use Policy
            </Text>
          </Link>

          <Link to={footerLinks.legal.privacyPolicy}>
            <Text color="black" mb={2}>
              Privacy Policy
            </Text>
          </Link>

          <Link to={footerLinks.legal.terms}>
            <Text color="black" mb={2}>
              Website T&Cs
            </Text>
          </Link>
        </Box>

        {/* Download App Column */}
        <Box mb={[4, 0]}>
          <Text fontWeight="600" textTransform="uppercase" mb={3}>
            DOWNLOAD APP
          </Text>
          <DownloadButtons noLink isVertical maxHeight="50px" maxWidth="100px" />
        </Box>
      </Flex>
      
      {/* Powered by Genflow footer */}
      <Flex justifyContent="left" alignItems="center" borderTop="1px solid #ccc" pt={3} maxWidth="1300px"  px={5}>
        <ExternalLink href="https://genflow.com/" target="_blank" rel="noopener noreferrer">
          <Image src={Genflow} alt="Genflow" width="100px" />
        </ExternalLink>
        <Text fontSize="12px" ml={2}>© 2025. All Rights Reserved</Text>
      </Flex>
    </Box>
  );
};

export default Footer;
